enum AudienceInsightsSource {
  Submission = 'submission',
  Identity = 'identity',
}

export { AudienceInsightsSource }
